import { Box, Grid, Tab, Tabs, useTheme } from "@mui/material";
import { IconDirections } from "@tabler/icons-react";
import { IconFileInfo } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import StateDetails from "./details";
import DistrictList from "../district-configuration/list";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setDistrictFilteredData } from "store/app/form-management/district-configuration/actions";

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <div
            id={`simple-tabpanel-${index}`}
            role="tabpanel"
            hidden={value !== index}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index &&
                <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const StateDetailsTab = (props) => {

    const { districtFilterData } = props;

    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [currentState, setCurrentState] = useState();

    useEffect(() => {

        return () => {
            const filterData = { ...districtFilterData };
            delete filterData?.statename;
            setTimeout(() => {
                props.setDistrictFilteredData(filterData);
            }, 0);
        }
    }, [])

    const tabStyle = {
        '& a': {
            minHeight: 'auto',
            minWidth: 10,
            px: 1,
            py: 1.5,
            mr: 2.25,
            color: theme.palette.mode === 'dark' ? 'grey.600' : theme.palette.text.primary,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
        },
        '& a.Mui-selected': {
            color: theme.palette.secondary.main
        },
        '& a > svg': {
            marginBottom: '0px !important',
            marginRight: 1.25
        },
        mb: 3
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid Container>
            <Tabs
                value={value}
                indicatorColor="secondary"
                textColor="secondary"
                onChange={handleChange}
                variant="scrollable"
                aria-label="simple tabs example"
                sx={tabStyle}
            >
                <Tab icon={<IconFileInfo />} component={Link} to="#" label="Overview" {...a11yProps(0)} />
                <Tab icon={<IconDirections />} component={Link} to="#" label="District" {...a11yProps(1)} />
            </Tabs>
            <TabPanel value={value} index={0}>
                <StateDetails setCurrentState={setCurrentState} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <DistrictList
                    selectedState={currentState?.name}
                    selectedStateId={currentState?.id}
                    stateStatus={currentState?.status}
                />
            </TabPanel>
        </Grid>
    )
}

const mapStateToProps = (state) => ({
    districtFilterData: state.districts.districtFilterData,
})

const mapDispatchToProps = (dispatch) => ({
    setDistrictFilteredData: (filter) => dispatch(setDistrictFilteredData(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StateDetailsTab);